import { render, staticRenderFns } from "./OfficialSeal.vue?vue&type=template&id=35639a53&scoped=true"
import script from "./OfficialSeal.vue?vue&type=script&lang=js"
export * from "./OfficialSeal.vue?vue&type=script&lang=js"
import style0 from "./OfficialSeal.vue?vue&type=style&index=0&id=35639a53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35639a53",
  null
  
)

export default component.exports